module.exports = __webpack_public_path__ + "static/img/ttr07.6bde86a.png";